import { useNavigate } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import { imgUrl, fmtGram, lineHasParts } from "@/lib/format";
import { useCart } from "@/context/CartContext";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function ProductCard({ product, index = 0 }) {
  const navigate = useNavigate();
  const { add } = useCart();
  const { user } = useAuth();
  const hideMilyem = user?.hide_milyem;
  const outOfStock = product.stock_status === "Stokta Yok";
  const { total: unitHas } = lineHasParts(product, 1);

  return (
    <div
      data-testid={`product-card-${product.id}`}
      className="group bg-surface border border-border rounded-md overflow-hidden animate-fade-up cursor-pointer"
      style={{ animationDelay: `${Math.min(index, 12) * 40}ms` }}
      onClick={() => navigate(`/product/${product.id}`)}
    >
      <div className="relative aspect-[4/5] overflow-hidden bg-elevated">
        {product.image_url ? (
          <img
            src={imgUrl(product.image_url)}
            alt={product.name}
            loading="lazy"
            decoding="async"
            className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-muted-foreground text-xs">Görsel yok</div>
        )}
        {outOfStock && (
          <span className="absolute top-2 left-2 bg-black/80 border border-red-500/40 text-red-400 text-[10px] px-2 py-1 rounded">
            Stokta Yok
          </span>
        )}
        <span className="absolute top-2 right-2 bg-black/70 text-gold text-[10px] px-2 py-1 rounded border border-gold/30">
          {product.karat} Ayar
        </span>
      </div>
      <div className="p-3">
        <p className="text-sm font-medium text-foreground line-clamp-1">{product.name}</p>
        <p className="font-mono text-[11px] text-muted-foreground mt-0.5">{product.code}</p>
        <div className="flex items-center gap-2 mt-1 text-[11px] text-muted-foreground">
          {!hideMilyem && (<><span>İşçilik {product.milyem || 0} milyem</span><span className="text-border">•</span></>)}
          <span>Has {fmtGram(unitHas)} gr</span>
        </div>
        <div className="flex items-center justify-between mt-3">
          <span className="text-gold font-semibold text-sm" title="Tahmini gram">{product.gram_min && product.gram_max ? `~${fmtGram(product.gram_min)}–${fmtGram(product.gram_max)} gr` : `~${fmtGram(product.gram)} gr`}</span>
          <button
            data-testid={`add-to-cart-${product.id}`}
            disabled={outOfStock}
            onClick={(e) => {
              e.stopPropagation();
              add(product, 1);
              toast.success("Sepete eklendi", { description: product.name });
            }}
            className="p-2 rounded-md bg-gold text-obsidian hover:bg-gold-hover transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
            aria-label="Sepete ekle"
          >
            <ShoppingBag size={16} strokeWidth={2} />
          </button>
        </div>
      </div>
    </div>
  );
}
